// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/todoList","todoList":"todoList-m__todoList___yRMt","cardList":"todoList-m__cardList__1dkaX"};